import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-zinc-800 rounded-lg overflow-hidden" data-id="element-10">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between gap-4 p-6 text-left bg-zinc-900 hover:bg-zinc-800 transition-colors" aria-expanded={isOpen} data-id="element-11">
        <span className="font-bold text-white text-lg" data-id="element-12">{question}</span>
        <ChevronDownIcon className={`h-6 w-6 text-cyan-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-13" />
      </button>

      {isOpen && <div className="p-6 bg-zinc-950 border-t border-zinc-800" data-id="element-14">
          <p className="text-gray-300 leading-relaxed" data-id="element-15">{answer}</p>
        </div>}
    </div>;
}